import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurDeleteModal({ deleteType, handleDeleteModal, handleCancelModal }) {

  /* Delete Types:
    list: delete a list
    listTrainer: delete a trainer from a list
    requestTrainers: delete all trainers from request (step5)
    requestTrainer: delete a trainer from request (step5)
    delegation: delete a delegation person from delegation liste
    deleteRecognitionDraft: Annuler un brouillon
  */

  return (
    <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="deleteModalTitle">
              {deleteType === 'deleteRecognitionDraft' ? (
                window.Drupal.t('fournisseur.delete.modal.deleteRecognitionDraft.title')
              ) : deleteType === 'list' ? (
                window.Drupal.t('fournisseur.delete.modal.list.title')
              ) : deleteType === 'listTrainer' || deleteType === 'delegation' ? (
                window.Drupal.t('fournisseur.delete.modal.list.trainer.title')
              ) : (
                window.Drupal.t('fournisseur.delete.modal.trainer.title')
              )}
            </h2>

            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            {deleteType === 'deleteRecognitionDraft' ? (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.deleteRecognitionDraft.body') }}></div>
            ) : deleteType === 'list' ? (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.list.body') }}></div>
            ) : deleteType === 'listTrainer' ? (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.list.trainer.body') }}></div>
            ) : deleteType === 'requestTrainers' ? (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.trainers.body') }}></div>
            ) : deleteType === 'delegation' ? (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.delegation.body') }}></div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.delete.modal.trainer.body') }}></div>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-center">
            <button type="button" className='button btn-larger' data-dismiss="modal" onClick={handleCancelModal}
            >{window.Drupal.t('fournisseur.back.btn')}</button>
            <button type="button" className='button btn-larger btn-red' data-dismiss="modal" onClick={handleDeleteModal}>
              {deleteType === 'deleteRecognitionDraft' ? (
                window.Drupal.t('fournisseur.delete.modal.deleteRecognitionDraft.btn')
              ) : deleteType === 'list' ? (
                window.Drupal.t('fournisseur.delete.modal.list.btn')
              ) : deleteType === 'requestTrainers' ? (
                window.Drupal.t('fournisseur.delete.modal.trainers.btn')
              ) : deleteType === 'delegation' ? (
                window.Drupal.t('fournisseur.delete.modal.delegation.btn')
              ) : (
                window.Drupal.t('fournisseur.delete.modal.trainer.btn')
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurDeleteModal.propTypes = {
  deleteType: PropTypes.string,
  handleDeleteModal: PropTypes.func,
};
